import { createContext } from "react";

export const ModalType = {
  SEARCH_TAG: "SEARCH_TAG"
};

export const CommonModalContext = createContext();
